module.exports = {
  "id": "crystal",
  "title": "crystal",
  "image": "provision/parts/crystal/crystal.png",
  "info": [
    {
      "text": "Add crystals to your project",
      "image": "provision/parts/crystal/crystal.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/crystal/crystal.png"
} ;